var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452,0H60A60.07,60.07,0,0,0,0,60v80H40V60A20,20,0,0,1,60,40H452a20,20,0,0,1,20,20V452a20,20,0,0,1-20,20H60a20,20,0,0,1-20-20V372H0v80a60.07,60.07,0,0,0,60,60H452a60.07,60.07,0,0,0,60-60V60A60.07,60.07,0,0,0,452,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "240 131.72 211.72 160 287.72 236 0 236 0 276 287.72 276 211.72 352 240 380.28 364.28 256 240 131.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLog);
export default __webpack_public_path__ + "static/media/iconLog.aa0ba01daffafb41b99ed408b21524f6.svg";
export { ForwardRef as ReactComponent };